<template>
    <v-btn
        class="more-btn tw-h-[42px] sm:tw-h-12 tw-flex tw-flex-row tw-justify-start tw-rounded-lg tw-border-gray-300 tw-bg-white tw-text-xs tw-font-normal tw-normal-case tw-tracking-wider sm:tw-text-sm"
        v-bind="btnBinds"
        variant="outlined">
        <template #prepend>
            <component
                :is="props.icon"
                v-if="props.icon"
                class="tw-size-4 sm:tw-size-5 tw-text-dark" />
        </template>
        <slot></slot>
        <template #append>
            <ArrowRightIcon class="tw-size-4 sm:tw-size-5 tw-text-gray-400" />
        </template>
    </v-btn>
</template>

<script setup lang="ts">
    import type { RouteLocationAsRelativeGeneric } from 'vue-router';
    import ArrowRightIcon from '@/components/icons/ArrowRight.vue';

    const props = defineProps<{
        to?: RouteLocationAsRelativeGeneric | string;
        icon?: any; // Use a more specific type if possible
        href?: string;
        target?: string;
        onClick?: () => void;
    }>();

    const emit = defineEmits<{
        click: [];
    }>();

    const btnBinds = computed(() => {
        const binds: any = {
            to: props.to ? props.to : undefined,
            href: props.href ? props.href : undefined,
            target: props.target ? props.target : undefined,
        };

        // Only add click handler if no navigation props are provided
        if (!props.to && !props.href && (props.onClick || emit)) {
            binds.onClick = props.onClick || (() => emit('click'));
        }

        return binds;
    });
</script>

<style scoped></style>
